<template>
  <v-dialog
    v-model="show"
    max-width="1200"
    :fullscreen="this.$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-row align="center" class="pa-5 ma-0">
        <v-col>
          <div class="text-left display-1">
            Gebruiksvoorwaarden
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card
            flat
            class="pa-5"
            style="overflow-y: scroll; max-height: 450px"
          >
            <v-card-text>
              {{
                this.$organization.loyalty_template_settings
                  .terms_and_conditions
              }}
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            flat
            class="pa-5"
            style="overflow-y: scroll; max-height: 450px"
          >
            <v-card-text>
              {{
                this.$organization.loyalty_template_settings.privacy_statement
              }}
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConditionsDialog",
  props: ["init_tab", "value"],
  mounted() {
    if (this.init_tab) {
      this.tab = this.init_tab;
    }
  },
  data() {
    return {
      tab: 0,
      items: ["Gebruikersvoorwaarden", "Privacybeleid"]
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    trigger() {
      return this.$store.getters["viewstate/conditionsDialogTrigger"];
    }
  },
  watch: {
    show: function(val) {
      if (val) {
        //setting tab
        if (this.init_tab) {
          this.tab = this.init_tab;
        } else {
          this.tab = 0;
        }
      }
    },
    trigger: function() {
      this.show = true;
    }
  }
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
